export default {
  form: {
    versions: {
      label: 'Versione',
      placeholder: 'Seleziona versione',
    },
    font_family: {
      label: 'Famiglia di caratteri',
    },
    background_color: {
      label: 'Colore di sfondo',
    },
    promo_frame_primary_color: {
      label: 'Colore cornice promo',
    },
    promo_frame_discount_label_color: {
      label: 'Colore sconto cornice promo',
    },
    vip_members_cta_color: {
      label: 'Colore CTA membri VIP',
    },
    url_cta_color: {
      label: 'Colore CTA URL',
    },
    url_color: {
      label: 'Colore URL',
    },
    url_type: {
      label: 'URL',
      placeholder: 'Seleziona URL',
    },
    url: {
      placeholder: 'www.example.com',
    },
    qr_code_border_color: {
      label: 'Colore bordo QR code',
    },
    qr_code_background_color: {
      label: 'Colore sfondo QR code',
    },
    footer_background_color: {
      label: 'Colore sfondo piè di pagina',
    },
    logo_zoom: {
      label: 'Dimensione logo',
    },
    logo: {
      label: 'Logo',
    },
  },
  toasts: {
    failed_to_load_data: "Impossibile caricare l'adesivo",
  },
};
